module.exports = __webpack_public_path__ + "img/sportaktiv.2aa50f52.svg";